import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'

import {
  DATE_FORMAT_SERVICE,
  DURATION_FORMAT_SERVICE,
  I18N_CONFIG_PROVIDER,
  LANGUAGE_SERVICE,
  UNIT_CONVERSION_SERVICE,
  UNIT_FORMATTING_SERVICE,
} from '@ti/core/contracts/i18n'

import {
  FormatDatePipe,
  FormatDaysBeforePipe,
  FormatDurationPipe,
  FormatTimeSincePipe,
  FormatTimezonePipe,
  FormatUnitPipe,
  TranslateLabelsPipe,
} from './pipes'
import { TimezoneOptionsProvider } from './providers'
import {
  DateFormatService,
  DurationFormatService,
  I18NConfigProvider,
  LanguageService,
  UnitConversionService,
  UnitFormattingService,
} from './services'

const STANDALONE_PIPES = [
  FormatDatePipe,
  FormatDaysBeforePipe,
  FormatDurationPipe,
  FormatTimeSincePipe,
  FormatTimezonePipe,
  FormatUnitPipe,
  TranslateLabelsPipe,
]

@NgModule({
  imports: [CommonModule, FormsModule, ...STANDALONE_PIPES],
  providers: [
    FormatDurationPipe,
    DateFormatService,
    UnitConversionService,
    FormatUnitPipe,
    TimezoneOptionsProvider,
    UnitFormattingService,
    { provide: DURATION_FORMAT_SERVICE, useExisting: DurationFormatService },
    { provide: LANGUAGE_SERVICE, useExisting: LanguageService },
    { provide: UNIT_CONVERSION_SERVICE, useExisting: UnitConversionService },
    { provide: DATE_FORMAT_SERVICE, useExisting: DateFormatService },
    { provide: I18N_CONFIG_PROVIDER, useExisting: I18NConfigProvider },
    { provide: UNIT_FORMATTING_SERVICE, useExisting: UnitFormattingService },
  ],
  exports: [...STANDALONE_PIPES],
})
export class I18nModule {}
